export default class ClipboardManager {
  /**
   * Copies text to the clipboard using the best available method.
   * @param {string} text - The text to copy.
   * @param {Function} [onSuccess] - Callback function for success.
   * @param {Function} [onError] - Callback function for failure.
   */
  copyText(text, onSuccess = () => {}, onError = (err) => console.error(err)) {
    if (!text) {
      onError("No text provided to copy.");
      return;
    }

    // Modern Clipboard API (preferred method)
    if (
      navigator.clipboard &&
      typeof navigator.clipboard.writeText === "function"
    ) {
      navigator.clipboard
        .writeText(text)
        .then(() => {
          console.log("Text copied successfully!");
          onSuccess();
        })
        .catch((err) => {
          console.error("Clipboard API failed, using fallback:", err);
          ClipboardManager.fallbackCopyText(text, onSuccess, onError);
        });
    } else {
      // Use fallback if Clipboard API is not supported
      ClipboardManager.fallbackCopyText(text, onSuccess, onError);
    }
  }

  /**
   * Fallback method using document.execCommand("copy") for older browsers.
   * @param {string} text - The text to copy.
   * @param {Function} onSuccess - Callback function for success.
   * @param {Function} onError - Callback function for failure.
   */
  static fallbackCopyText(text, onSuccess, onError) {
    try {
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "absolute";
      textArea.style.left = "-9999px"; // Move off-screen
      document.body.appendChild(textArea);
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);

      if (successful) {
        console.log("Text copied successfully using fallback method!");
        onSuccess();
      } else {
        throw new Error("Fallback method failed.");
      }
    } catch (err) {
      console.error("Copy to clipboard failed:", err);
      onError(err);
    }
  }
}

// Example Usage:
// ClipboardManager.copyText(
//   "Hello, World!",
//   () => alert("Copied Successfully! 🎉"),
//   (err) => alert("Failed to Copy! ❌ " + err)
// );
